<template>
  <div v-if="clusters" class="cluster-body" :class="{'context-v5' : isV5Modal}">
    <div class="safe-area-blur"></div>
    <cluster-meta class="cluster-meta-body" :slug="getSlug" :node="getNode" :style="{ gridRow: `span ${clusters.length}`}" />

    <!-- dynamic component, so that the alts (banners) can be different actual components -->
    <!-- :class="{ 'expanded' : clusterIsExpanded(i), 'collapsed' : !clusterIsExpanded(i) }" -->
    <div class="node-body-wrapper" ref="scrollWrapper">
      <component :is="cluster.component"
        v-for="(cluster, i) in clusters" :key="i"
        :slug="getSlug"
        :node="getNode"
        :focus="clusterIsFocused(i)"
        :cluster="cluster"
        :cluster-index="i"
      />
    </div>
    <Publishers/>
  </div>
  <Loading v-else/>
</template>

<script>
  import utils from '@assets/js/utils.js';
  import layout from '@assets/js/layout.js';
  import story from '@assets/js/news/story-utils.js';

  import Node from 'app/components/_v3.3/news/story/Body/Node.vue';
  import EndCard from 'app/components/_v3.3/news/story/Body/EndCard.vue';
  import ClusterMeta from 'app/components/_v3.3/news/story/Body/ClusterMeta.vue';

  // import Onboarding from 'app/components/_v3.3/common/Onboarding';
  import Publishers from 'app/components/_v6/modal/Publishers.vue' 

  export default {
    mixins: [story, utils, layout],
    props: {
      slug: String,
      node: String,
      context: String,
      // v5 - in Stack hack
      opts: Object,
    },
    components: {
      Node,
      EndCard,
      ClusterMeta,
      Publishers,
    },

    data: function() {
      return {
        raw: {},
        flags: {
          nodesReady: false,
          scrollActive: false,
          scrollSync: false,
          ignoreNextSIV: false,
        },
        publisherModal: {
          visible: false,
          publishers: null,
        }
      };
    },

    computed: {
      getSlug () {
        return this.opts?.slug || this.slug;
      },
      getNode () {
        return this.opts?.node || this.node;
      },
      getContext () {
        return this.opts?.context || this.context;
      },
      

      isV5Modal () {
        return false; // this.$route.fullPath.replace(/^\//,'').split('/')[0] == 'v5';
      },
      expanded() {
        return Boolean(this.getNode);
      },
      model() {
        return this.$store.getters.getStoryV3(this.getSlug) || {};
      },
      clusters() {
        return this.$dataEngine.clustersGet();
      },
      // statements() {
      //   const timeseries = this.timeseries;
      //   let statements = []

      //   timeseries.forEach(series => {
      //     statements << series.statements
      //   })

      //   return statements
      // }
    },

    methods: {      
      focus() {
        if (this.flags.ignoreNextSIV) {
          // console.log(`Body: Focus - Browser is handling the snap. Backing off`);
          this.flags.ignoreNextSIV = false;
          return;
        }
      },

      focus_DISABLED(slug) {
        // grab the node..
        let eNode = document.querySelector(`[data-node="${slug}"]`);
        
        if (!eNode) {
          return;
        }

        // // calculate the target
        let iTop = eNode.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - 120;
        
        // flag that we're moving (for ~1s), debounced
        if (this.flags.scrollActive) {
          window.clearTimeout(this.flags.scrollActive);
        }
        this.flags.scrollActive = window.setTimeout(() => this.flags.scrollActive = false, 1000);

        if (this.flags.ignoreNextSIV) {
          // console.log(`Body: Focus - Browser is handling the snap. Backing off`);
          this.flags.ignoreNextSIV = false;
          return;
        }

        // scroll into position..
        // console.log(`Scrolling to: ${iTop}`);
        window.scrollTo({ top: iTop, left: 0, behavior: 'smooth' });
        // eNode.scrollIntoView({behavior: "smooth", block: "end"});
      },

      IOCreate(boxElement){
          let observer;
          let minThresh = 0.2;
          let maxThresh = 0.8;

          let aThreshold = [...Array(Math.round((maxThresh - minThresh) * 10)).keys()].map(a => +((a / 10) + minThresh).toFixed(1));

          // console.log(`Body: Intersection Observer (Create): `, aThreshold);

          let options = {
            root: null,
            rootMargin: "-10% 0px -10% 0px",
            threshold: aThreshold,
          };
          observer = new IntersectionObserver(this.IOHandle, options);
          observer.observe(boxElement);
          // console.log(`Body: Intersection Observer (Create): `, boxElement, options);
      },

      IOHandle(oIntersect){
        // we only care about the first one (not sure I understand how > 1?)
        oIntersect = oIntersect[0];
        // // console.log(`Body: Intersection -- BEGINS`, oIntersect);

        // we only care about those that are newly intersecting
        if (!oIntersect.isIntersecting) {
          // console.log(`Body: Intersection -- IGNORING (Already Intersecting)`, oIntersect);
          return;
        }

        // ignore while we're in the middle of transitioning
        if (this.flags.scrollActive) {
          // console.log(`Body: Intersection -- IGNORING (Busy)`, oIntersect);
          return;
        }

        let sNode = oIntersect.target.dataset.node;
        let sPath = this.getNodePath(sNode);

        if (sPath == this.$route.fullPath) {
          // console.log(`Body: Intersection -- IGNORING (Already at ${sPath} (from: ${this.$route.fullPath}))`, oIntersect);
          return;
        }

        // console.log(`Body: Intersection. Firing navigation: ${sNode}, ${sPath} (from: ${this.$route.fullPath})`, oIntersect);

        // route to the element, let the route-watcher do the work..
        this.flags.ignoreNextSIV = true;
        

        let sBase = this.$route.fullPath.replace(/^\//,'').split('/')[0];
        let sCurrentNode = this.$route.fullPath.replace(/^\//,'').split('/')[2];

        // console.log(`[ROUTER] -- [${sBase}] Body: replace(${sPath}) [Scroll: ${window.scrollY}] Node: `, sCurrentNode);

        if (sBase == 'v5') { 
          console.log('Router push')
          this.$router.push(sPath);
        } else {
          let iScroll = this.$refs.scrollWrapper.scrollTop;
          // console.log(`Body: Intersection. RULES:: ${window.scrollY} / ${iScroll}, ${sCurrentNode}`);
          // Nourish v2 -- scroll now happens on `.node-body-wrapper`
          if ((iScroll > 250) || (window.scrollY > 250) || sCurrentNode) {
            // don't manipulate the URL in the 'stack' context (although, this is problematic for sure! ... how does the n'th node load!?)
            if (this.getContext == 'stack') {
              console.log('Force story nav')
              this.$dataEngine.forceStoryNav({
                slug: this.getSlug,
                node: sNode,
              });
            } else {
              this.$router.replace(sPath);
              // Reduce history count to handle external entry correctly
              this.$router.historyCount--;
            }
          }
        }
      },

      // IOBalance(){
      //   if (!this.$el.childElementCount) {
      //     return;
      //   }

      //   let aClusters = this.$el.querySelectorAll('[data-node]');
      //   aClusters.forEach((e) => {
      //     let eFaux = document.body.querySelector(`[data-scrollsnap="${e.dataset.node}"]`);
      //     if (!eFaux) {
      //       return;
      //     }
      //     eFaux.style.height = e.clientHeight + 'px';
      //     // for now, force the Ele.cluster to maintain its height too - hacky hack..
      //     // e.style.height = e.clientHeight + 'px';
      //   });
      // }
      doSetup() {
        // console.log("Body: Clusters Watch Setup... (NOW)");
        let aElements = this.$el.querySelectorAll('[data-node]');
        if (!aElements.length || this.flags.nodesReady) {
          // console.log("Body: Clusters Watch Setup... (! Nothing ready..)");
          return;
        }

        // console.log(`Body: Intersect Setup...`, this.$el, aElements, to, from);
        aElements.forEach((e) => {
          this.IOCreate(e);
        });

        // console.warn(navigator.userAgent);
        // Do not snap in Safari, for now..
        // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        // if (isSafari) {
        //   return;
        // }

        // // create scroll blocks.. 
        // document.body.dataset.scrollsnap = 'on';
        // document.body.querySelectorAll('[data-scrollsnap]').forEach(e => e.parentNode.removeChild(e));
        // let aReversed = [].slice.call(aElements, 0).reverse();
        // aReversed.forEach((e) => {
        //   let eDiv = document.createElement("div");
        //       eDiv.dataset.scrollsnap = e.dataset.node;
        //       eDiv.classList = ['faux-scrollsnap'];
        //   document.body.prepend(eDiv);
        // });
      }
    },

    watch: {
      // $route(to) {
      //   // console.log(`Body: Route Focus: ${to.params.node}`, to);
      //   this.focus(to.params.node);
      // },
      
      // slug() {
      //   document.body.querySelectorAll('[data-scrollsnap]')?.forEach(e => e.parentNode.removeChild(e));
      //   document.body.removeAttribute('data-scrollsnap');
      // },

      clusters(to, from) {
        // IOCreate();
        // console.log("Body: Clusters Watch Trigger... ", to.length == from.length, to, from);

        if (to.length == from.length) {
          return;
        }

        // console.log("Body: Clusters Watch Setup... ");
        window.setTimeout(this.doSetup, 10);
      },
    },

    mounted() {
      // console.log(`MOUNT: `, this.$el.querySelectorAll('[data-node]'));
      if (this.$el.querySelectorAll('[data-node]')) {
        // already loaded, not cluster mutation will happen..
        window.setTimeout(this.doSetup, 10);
      }
      this.EventBus.$emit('header:title', {
        title: false,
        direction: 'forward',
      });
      // this.flags.scrollSync = window.setInterval(this.IOBalance, 100);
    },

    // beforeDestroy(){
    //   if (this.flags.scrollSync) {
    //     window.clearInterval(this.flags.scrollSync);
    //   }
    // }
  }
</script>
<style lang="scss">
  @import 'src/assets/scss/__2020_v3.scss';
  @import 'src/assets/scss/v5.scss';

  .cluster-body {
    position: relative;
    max-width: $desktop-max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: $desktop-grid-main $desktop-grid-aside;
    height: $desktop-grid-height;
    overflow: hidden;
    border-left: 1px solid rgba($neutral-400, 0.25);
    border-right: 1px solid rgba($neutral-400, 0.25);

    @media (max-width: 850px) {
      grid-template-columns: 1fr;
      height: auto;
      border-left: unset;
      border-right: unset;
    }

    // max-width: 1400px;
    // margin: 0em auto 0 auto;
    // padding: 2rem 2em 2rem 2em;

    // display: grid;
    // grid-gap: 1em 8em;
    // // grid-template-columns: 240px 1fr 240px;
    // // grid-template-columns: 3fr 6fr 3fr;
    // grid-template-columns: auto 20rem;

    // &::before {
    //   content: '';
    //   position: absolute;
    //   display: inline-block;
    //   width: 1px;
    //   height: 100%;
    //   background: rgba($neutral-400, 0.2);
    //   top: 0;
    //   margin-left: 35px;
    //   z-index: 40;

    //   .mq-sm & {
    //     margin-left: 16px;
    //   }
    // }

    .cluster-cta {
      display: none;
      margin: 0 1.3rem;

      .mobile & {
        display: flex;
      }
    }

    .cluster-meta-body {
      order: 2;
      grid-column: span 1;
      // background: rgba(255, 0, 0, 0.05);
      .mobile & {
        max-width: 100%;
        margin: 0;
        grid-row: span 1 / auto !important; // overwrite the programatic style:span
        order: -1; // pop back at the top.. 
      }

      // .mq-sm & {
      //   display: none;
      // }
    }

    &.context-v5 {
      // margin-top: 1em;
      padding: calc(env(safe-area-inset-top) + 1.5rem) 1rem;

      // .desktop & {
      //   .cluster-meta {
      //     display: none;
      //   }
      // }
    }

    .mobile & {
      grid-template-columns: 100%;
      max-width: 100%;
      // grid-gap: 1rem;
      // padding: 1rem 0;
      margin: 0;
      padding: 0;
      // background: red;
    }

    .mobile.is-app & {
      // margin-top: 1.5rem;

      // update: 2024 -- all of this bollocks appears to be taken care of elsewhere.. so 0
      // padding: calc(env(safe-area-inset-top) + $header-height + 1.5rem) 0;
      padding: 0;
    }

    &.context-v5 {
      .mobile & {
        // margin: 1.5rem 0;
        padding: calc(env(safe-area-inset-top) + 1.5rem) 0;
      }
    }
    
  }








  // scrollsnap hacks
  html, body {
    height: 100%;
  }

  body {
    // scroll-snap-type: y mandatory;
  }


  .faux-scrollsnap {
    // scroll-snap-align: start;

    width: 0px;

    // MUST MATCH: real elements v faux elements
    min-height: 100vh;
    // padding-bottom: 25vh;

    float:left;
    clear:left;

    .mobile & {
      min-height: 200vh;
    }
    // border: 2px solid red;
    // background: rgba(255, 0, 0, 0.1);
    // &:nth-child(odd) {
    //   border: 2px solid green;
    //   background: rgba(0, 255, 0, 0.1);
    // }
  }

  /**
   * -- Disable some padding/layout hacks when scroll-snap is not in place.
   */
  // body:not([data-scrollsnap]) {
  //   scroll-snap-type: none;
  //   padding-bottom: initial;
  //   .mobile & {
  //     min-height: initial;
  //   }
  // }

  // mobile..
  // simplify (ie disable) body scroll elasticity & bouce
  // ** See also: _v3.3.vue
  body.mobile {
    width: 100vw;
    height: 100vh;
    // position: fixed;
    // overflow: hidden;

    .v3-faux-top {
      display: none !important;
    }
  }
  

</style>

<style lang="scss" scoped>
  @import 'src/assets/scss/__2020_v3.scss';
  @import 'src/assets/scss/v5.scss';

  .node-body-wrapper {
    height: $desktop-grid-height;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 850px) {
      height: auto;
      grid-row: 1;
    }

    background: $neutral-600;

    .darkmode & {
      background: $neutral-100;
    }

    .desktop & {
      .darkmode & {
        background: $neutral-100;
      }
    }
  }

  .safe-area-blur {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: env(safe-area-inset-top);
    backdrop-filter: blur(3px);
    z-index: 2;
  }
</style>